export const styles = {
  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: { xs: 48, sm: 64 },
    paddingX: { xs: 2, sm: 3 },
    borderBottom: '1px solid',
    borderColor: 'divider',
  },
  locationPill: { borderRadius: 14 },
}
